module.exports = __webpack_public_path__ + "images/home-slides/livingroom.027d94d951e8de3b442c8dddd4ed6845.jpg";